// extracted by mini-css-extract-plugin
export default {"spin":"The0MissionIcon_spin__8c3jp"};